var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconProjectType = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.056,
    height: 11.644,
    viewBox: "0 0 9.056 11.644",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_turned_in_24px",
    d: "M12.762,3H6.294A1.292,1.292,0,0,0,5.006,4.294L5,14.643,9.528,12.7l4.528,1.941V4.294A1.3,1.3,0,0,0,12.762,3Z",
    transform: "translate(-5 -3)",
    fill: "#727272"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconProjectType);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-project-type.a359298ed7a395b72d0744198c81f3be.svg";